// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"7419700e","477":"8df68009"}[chunkId] + ".chunk.js";
};